import API from "../config/api.js";

export const GlAccountService = {

    getBranches() {
    
        return API.get("/api/inventory/branches");
      },
    getAccountTypes() {
        return API.get("/api/gl-sub/GlAccountTypes");
    },
    async createGlAccount(formData){
        try{
            const response = await API.post('/api/gl-accounts/create', formData);
            return response.data; 
          }catch (error) {
            console.error("Error Adding GL Accountr:", error);
            throw error;
          } 
    },
    getSubHeaders(id) {
        return API.get(`/api/gl-accounts/subheaders/${id}`);
    },

}